import React from 'react'
import { Field, reduxForm } from 'redux-form'
import  validate  from './../validateReg';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';


import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EmailField from '../EmailField';
import TextField from '../TextField';
import PasswordField from '../PasswordField';
import PhoneField from '../PhoneField';
import ProjectCodeField from '../ProjectCodeField';
import RenderCheckbox from '../AmLeader';
import Dropdown from '../Dropdown';

import { commonStyles } from '../../../styles/styles';
import DatePicker from '../DatePicker';

import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput } from "mdbreact";
import { registrationRequest, loginReset } from '../../../redux/reducers/login';



const SecondPage = ({ classes, form, pristine, previousPage, submitting, ...props }) => {
  
  const { handleSubmit, dropdowns, checkCode } = props;
 
  return (
    // <div className={classes.regFormWrapper}>
    //   <h4 className={classes.pageNo}>Page 1 of 5</h4>
    //   <form onSubmit={handleSubmit}>
    //   <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="birthdate" label="Date of Birth" component={DatePicker}  />
    //     </div>
    //     <div className={`${classes.halfField}`}>
    //       <Field name="employeeNo" label="Employee Number (Optional)" component={TextField}  />
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field className={`${classes.dropdown}`} name="conIdentificationTypeID" label="ID Type" component={Dropdown}   options={dropdowns.dropdowns.idendityTypes}/>
    //     </div>
    //     <div className={`${classes.halfField}`}>
    //     <Field name="conTitleID" label="Title" component={Dropdown}  options={dropdowns.dropdowns.titles} />
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="conRegion" label="Region" component={Dropdown}   options={checkCode.codeMessage.regions}/>
    //     </div>
    //     <div className={`${classes.halfField}`}>
    //     <Field name="conBranch" label="Branch" component={Dropdown}  options={checkCode.codeMessage.branches} />
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="language" label="Home Language" component={Dropdown}  options={dropdowns.dropdowns.languages}/>
    //     </div>
    //     <div className={`${classes.halfField}`}>
    //       <Field name="gender" label="Gender" component={Dropdown}   options={dropdowns.dropdowns.gender}/>
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="race" label="Population Group" component={Dropdown}  options={dropdowns.dropdowns.race}/>
    //     </div>
    //     <div>
    //       <div className={`${classes.halfField}`} styles="justifyContent: 'right', display: 'inline-flex'">
    //         <button variant="contained"
    //           className={`${classes.defaultButton} ${classes.shortButton}`} type="button"  onClick={previousPage}>Previous</button>
    //       </div>
    //       <div className={classes.halfField}>
    //         <button variant="contained"
    //           className={`${classes.defaultButton} ${classes.shortButton}`} type="submit" >Next</button>
    //       </div>
    //     </div>
    //   </form>
    // </div>
    <form className="w-100"  onSubmit={handleSubmit}>
      <MDBCol md="12">
      <MDBRow>
    
        
        <MDBCol md="12">
        <Field name="employeeNo" label="Employee Number" component={TextField}  />
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol md="12">
        {dropdowns.dropdowns && <Field name="race" label="Population Group" component={Dropdown}  options={dropdowns.dropdowns.race}  depth={10009}/>}
        </MDBCol>

      </MDBRow>
      <MDBRow>
        <MDBCol md="6">
        {dropdowns.dropdowns && <Field className={`${classes.dropdown}`} name="conIdentificationTypeID" label="ID Type" component={Dropdown}   options={dropdowns.dropdowns.idendityTypes}  depth={10008}/>}
        </MDBCol>
        <MDBCol md="6">
        {dropdowns.dropdowns && <Field name="conRegion" label="Region" component={Dropdown}   options={dropdowns.dropdowns.regions}  depth={10007}/>}
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol md="12">
        {dropdowns.dropdowns && <Field name="conBranch" label="Branch" component={Dropdown}  options={dropdowns.dropdowns.branches}  depth={10006}/>}
        </MDBCol>

      </MDBRow>
      <MDBRow>
        <MDBCol md="6">
        {dropdowns.dropdowns && <Field name="language" label="Home Language" component={Dropdown}  options={dropdowns.dropdowns.languages}  depth={10005}/>}
        </MDBCol>
    
      </MDBRow>
      <MDBRow className="mt-4">
          <MDBCol size="6">
            <MDBBtn 
                right
                size="md"
                className='mt-0 mb-2 float-left danger-color-dark'
                action
                onClick={previousPage}
                type="button">
              PREVIOUS
            </MDBBtn>
          </MDBCol>
          <MDBCol size="6">
            <MDBBtn color="success"
                right
                size="md"
                className='ml-3 mr-2 mt-0 mb-2 float-right'
                action
                type="submit">
              NEXT
            </MDBBtn>
          </MDBCol>
        </MDBRow>

    </MDBCol>
    </form>
  ); 
}



SecondPage.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  login: PropTypes.instanceOf(Object),
  form: PropTypes.instanceOf(Object),
};

const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
  dropdowns: state.dropdownsReducer,
  checkCode: state.checkCodeReducer,
});
const mapDispatchToProps = dispatch => ({
  registrationRequest: () => dispatch(registrationRequest()),
  loginReset: () => dispatch(loginReset()),
});


const styles = () => ({
  ...commonStyles,
  halfField: {
    display: 'inline-flex',
    width: '49%',
  },
  firstInRow: {
    marginRight: '5px',
  },
  label: {
    color: '#e84848',
  },
  dropdown:{
    border:'20px solid red'
    //borderRadius: '0 !important'
  },
  fullField: {
    width: '100%',
  },
  regFormWrapper: {
    maxWidth: '80%',
    margin: '0 auto',
  },
  rowWrapper: {
    display: 'flex',
  },
  noTopLabel: {
    paddingTop: 10,
    paddingLeft: 14,
  },
  pageNo:{
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',

  },
});

export default compose(
  reduxForm({ form: 'registration',
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  validate
 }),
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(SecondPage);
